import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { buttonsStyle } from "./table";

// FALTA CONTACTS + PARTNERTS + LANGUAGES PARA ABAJO

// FALTA EDIT BORRAR ORDER + EDIT ENABLE BORRAR ORDER

export function buttonFormatterEditDisableDelete(cell, nameObjectSingle, data, isAdmin, setElem, setOpenConfirmDialog, history) {
    const elem = data.find((item) => item.id === cell);
    return (
        <>
            <Tooltip title="Edit">
                <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => history.push(`/edit-${nameObjectSingle}/${cell}`)}
                >
                    <EditIcon />
                </Button>
            </Tooltip>
            {isAdmin && (
                <>
                    {<Tooltip title={elem?.active ? "Disable" : "Enable"}>
                        <Button
                            style={buttonsStyle}
                            size="small"
                            onClick={() => {
                                setElem(elem);
                                setOpenConfirmDialog(1);
                            }}
                        >
                            {elem?.active ? (
                                <ToggleOffIcon />
                            ) : (
                                <ToggleOnIcon style={{ color: "red" }} />
                            )}
                        </Button>
                    </Tooltip>}
                    <Tooltip title="Delete">
                        <Button
                            style={buttonsStyle}
                            size="small"
                            onClick={() => {
                                setElem(elem);
                                setOpenConfirmDialog(2);
                            }}
                        >
                            <DeleteIcon />
                        </Button>
                    </Tooltip>
                </>
            )}
        </>
    );
}

export function buttonFormatterEditDisable(cell, nameObjectSingle, data, isAdmin, setElem, setOpenConfirmDialog, history) {
    const elem = data.find((item) => item.id === cell);
    return (
        <>
            <Tooltip title="Edit">
                <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => history.push(`/edit-${nameObjectSingle}/${cell}`)}
                >
                    <EditIcon />
                </Button>
            </Tooltip>
            {isAdmin && (
                <>
                    {<Tooltip title={elem?.active ? "Disable" : "Enable"}>
                        <Button
                            style={buttonsStyle}
                            size="small"
                            onClick={() => {
                                setElem(elem);
                                setOpenConfirmDialog(1);
                            }}
                        >
                            {elem?.active ? (
                                <ToggleOffIcon />
                            ) : (
                                <ToggleOnIcon style={{ color: "red" }} />
                            )}
                        </Button>
                    </Tooltip>}
                </>
            )}
        </>
    );
}

export function buttonFormatterEditDelete(cell, nameObjectSingle, data, isAdmin, setElem, setOpenConfirmDialog, history) {
    const elem = data.find((item) => item._id === cell);
    return (
        <>
            <Tooltip title="Edit">
                <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => history.push(`/edit-${nameObjectSingle}/${cell}`)}
                >
                    <EditIcon />
                </Button>
            </Tooltip>
            {isAdmin && (
                <>
                    <Tooltip title="Delete">
                        <Button
                            style={buttonsStyle}
                            size="small"
                            onClick={() => {
                                setElem(elem);
                                setOpenConfirmDialog(2);
                            }}
                        >
                            <DeleteIcon />
                        </Button>
                    </Tooltip>
                </>
            )}
        </>
    );
}

